/* Existing Google Ads remarketing only; Shopify pixels own GA4 ecommerce. */
(function () {
  'use strict';

  if (window.__pfAdsEvents20260929) return;
  window.__pfAdsEvents20260929 = true;
  const destination = 'AW-18302569250';

  function record(name) {
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', name, { send_to: destination });
      }
    } catch (_) {
      // Analytics must never make a successful cart operation look unsuccessful.
    }
  }

  function isCartAdd(input, options) {
    try {
      const raw = typeof input === 'string' ? input : input && (input.url || input.href);
      if (!raw) return false;
      const url = new URL(raw, window.location.href);
      const method = (options && options.method) || (input && input.method) || 'GET';
      return String(method).toUpperCase() === 'POST'
        && url.origin === window.location.origin
        && /^\/(?:[a-z]{2,3}(?:-[a-z0-9]{2,8})*\/)?cart\/add(?:\.js)?\/?$/i.test(url.pathname);
    } catch (_) {
      return false;
    }
  }

  // Market prefix only; event ownership and fetch tracking stay unchanged.
  const routeRoot = [window.PFMarket?.root, window.Shopify?.routes?.root]
    .find(value => value === '/' || value === '/en-us/') || '/';
  const pathname = window.location.pathname;
  const path = routeRoot !== '/' && pathname.startsWith(routeRoot)
    ? '/' + pathname.slice(routeRoot.length) : pathname;
  if (/^\/products\//.test(path)) record('view_item');
  else if (/^\/cart/.test(path)) record('view_cart');

  const originalFetch = window.fetch;
  if (typeof originalFetch !== 'function') return;
  window.fetch = function (input, options) {
    const pending = originalFetch.apply(this, arguments);
    if (isCartAdd(input, options)) {
      pending.then(function (response) {
        if (response.ok === true) record('add_to_cart');
      }, function () {
        // Preserve the caller's rejection; a failed request is not an add.
      });
    }
    // Keep the original Promise, response body and shopping error semantics.
    return pending;
  };
})();
